import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider";
import { CountryProvider } from "./context/CountryProvider";
import theme from './theme';
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { Provider } from "react-redux";
import {store} from "./store/store"
// import { msalConfig } from "./pages/mslogin/authConfig";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { getMsalInstance } from "./pages/mslogin/authConfig";

//const msalInstance = new PublicClientApplication(msalConfig);
  
const root = ReactDOM.createRoot(document.getElementById("root"));

// Initialize app after fetching client secret from API
const initializeApp = async () => {
  try {
    const msalInstance = await getMsalInstance();

root.render(
  <div id="MainDiv">
    {/* <React.StrictMode> */}
      <Provider store={store}>
      {/* <BrowserRouter basename="SiMS_ReactJS/"> */}
      <BrowserRouter>
         <AuthProvider>
          <CountryProvider>
            <ThemeProvider theme={theme}>
              {/* <CssBaseline /> */}
              <MsalProvider instance={msalInstance}>
              <App />
              </MsalProvider>
            </ThemeProvider>
           </CountryProvider>
        </AuthProvider> 
      </BrowserRouter>
      </Provider>
    {/* </React.StrictMode> */}

    <footer style={{ display: "flex", justifyContent: "center" }}>
      © IQVIA All rights reserved.
    </footer>
  </div>
);
  } catch (error) {
    console.error("Error initializing app:", error);
    // Render error state or fallback
    root.render(
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div>Error initializing application. Please refresh the page.</div>
      </div>
    );
  }
};

// Start the app initialization
initializeApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


